import { createApiHook, useApi } from "../utils/apiUtils";

const useUpdateContactInfo = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const updateContactInfo = async (userId, payload) => {
    startLoading();
    const response = await apiPatch(`/users/${userId}/update_contact_info`, "Error al actualizar la información", payload);
    setResponse(response);
    return response;
  };

  return { updateContactInfo, data, loading, error };
};

export default useUpdateContactInfo;
